import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, OnInit } from '@angular/core';
import { InfoBoxComponent } from '../../components/utility/info-box/info-box.component';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { TipsideComponent } from '../../components/tipside-with-modal/tipside/tipside.component';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { ModalWithOneSelectComponent } from '../../components/modals/modal-with-one-select/modal-with-one-select.component';
import { HttpService } from '../../services/http.service';
import { StorageService } from '../../services/storage.service';
import { UserAccountDTO } from '../../classes/user-account.dto';
import { DataService } from '../../services/data.service';
import { NavigationMenuComponent } from '../../components/utility/navigation-menu/navigation-menu.component';
import { MedicalDataDTO } from '../../classes/api-dto';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-health-folder',
    imports: [InfoBoxComponent, TranslateModule, RouterModule, NzMenuModule, TipsideComponent, TipsideComponent, NzModalModule, NavigationMenuComponent],
    templateUrl: './health-folder.component.html',
    styleUrls: ['./health-folder.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HealthFolderComponent implements OnInit, OnDestroy {
  medicalData?: MedicalDataDTO;
  private destroy$ = new Subject<void>();

  constructor(
    private modal: NzModalService,
    private router: Router,
    private http: HttpService,
    private storage: StorageService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.getMedicalData();
  }

  private getMedicalData(): void {
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    this.http
      .medicalProfileData(userData.individualId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: MedicalDataDTO) => {
        this.dataService.setMedicalData(res);
        this.medicalData = res;
      });
  }

  protected openReportPage(): void {
    this.router.navigate(['/health-folder/reports']);
  }

  protected openPassportHealth(): void {
    this.modal.create({
      nzContent: ModalWithOneSelectComponent,
      nzClosable: true,
      nzFooter: null,
      nzData: {
        dataModal: {},
      },
    });
    /*     modalRef.afterClose.subscribe((result): void => {
      if (result instanceof FormControl) {
        console.log('TODO');
      }
    }); */
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
